/**
 * @type {string}
 * */
var version = JSON.parse("\"3.0.0-alpha.102\"");
export default version;